import {
  getFirebaseRemoteConfig,
  fetchAndActivate,
  getString
} from './javascript-firebase.js';

const sections = {
  "2.0": [
    "homepage-hero",
    "reviews",
    "how-it-works",
    "why-nomad",
    "pricing",
    "featured-in",
    "faq",
    "real-customer-stories",
    "contact"
  ],
  "1.0": [
    "homepage-hero-b",
    "featured-in-b",
    "why-nomad-b",
    "americas-largest-provider",
    "real-customer-stories-b",
    "pricing-b",
    "how-it-works-b",
    "reviews-b",
    "faq-b",
    "contact-b"
  ],
  "all": [
    "horizontal-green-bar"
  ]
}

async function initializeHomepageLayout() {
  try {
    const firebaseRemoteConfig = getFirebaseRemoteConfig();
    await fetchAndActivate(firebaseRemoteConfig);

    const activeHomepageVersion = getString(firebaseRemoteConfig, "homepage_version");
    // const activeHomepageVersion = "1.0"; // Hardcoded for testing purposes

    Object.keys(sections).forEach(version => {
      if (version !== activeHomepageVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[activeHomepageVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });
  } catch (error) {
    console.error("Error fetching remote config, using defaults:", error);

    const latestVersion = Object.keys(sections).filter(version => version !== "all").sort().pop();

    Object.keys(sections).forEach(version => {
      if (version !== latestVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[latestVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });
  }

  window.scrollTo(0, 0);
}

document.addEventListener('DOMContentLoaded', () => {
  const primaryCTAs = document.querySelectorAll('.primary-cta');

  primaryCTAs.forEach(cta => {
    cta.addEventListener('click', () => {
      gtag('event', 'primary_cta_click', {
        'source': 'homepage'
      });
    });
  });
})

initializeHomepageLayout();
